const NHL_TEAMS = [
  'Anaheim_Ducks',
  'Boston_Bruins',
  'Buffalo_Sabres',
  'Calgary_Flames',
  'Carolina_Hurricanes',
  'Chicago_Blackhawks',
  'Colorado_Avalanche',
  'Columbus_Blue_Jackets',
  'Dallas_Stars',
  'Detroit_Red_Wings',
  'Edmonton_Oilers',
  'Florida_Panthers',
  'Los_Angeles_Kings',
  'Minnesota_Wild',
  'Montreal_Canadiens',
  'Nashville_Predators',
  'New_Jersey_Devils',
  'New_York_Islanders',
  'New_York_Rangers',
  'Ottawa_Senators',
  'Philadelphia_Flyers',
  'Pittsburgh_Penguins',
  'San_Jose_Sharks',
  'Seattle_Kraken',
  'St_Louis_Blues',
  'Tampa_Bay_Lightning',
  'Toronto_Maple_Leafs',
  'Utah_Hockey_Club',
  'Vancouver_Canucks',
  'Vegas_Golden_Knights',
  'Washington_Capitals',
  'Winnipeg_Jets',
];

const PROP_OPTIONS = ['Seattle Seahawks', 'New England Patriots', 'Gatorade', 'Anthem'];

const OLYMPIC_TEAMS = [
  'USA',
  'Canada',
  'Denmark',
  'Germany',
  'Finland',
  'Czechia',
  'Italy',
  'Latvia',
  'Sweden',
  'France',
  'Switzerland',
  'Slovakia',
];

const NBA_TEAMS = [
  'Memphis Grizzlies',
  'LA Clippers',
  'Orlando Magic',
  'Oklahoma City Thunder',
  'Toronto Raptors',
  'Utah Jazz',
  'Houston Rockets',
  'Washington Wizards',
  'Miami Heat',
  'Cleveland Cavaliers',
  'Atlanta Hawks',
  'Indiana Pacers',
  'San Antonio Spurs',
  'Denver Nuggets',
  'LA Lakers',
  'Phoenix Suns',
  'New Orleans Pelicans',
  'New York Knicks',
  'Minnesota Timberwolves',
  'Detroit Pistons',
  'Philidelphia 76ers',
  'Boston Celtics',
  'Sacramento Kings',
  'Golden State Warriors',
  'Portland Trail Blazers',
  'Chicago Bulls',
  'Charlotte Hornets',
  'Milwaukee Bucks',
  'Dallas Mavericks',
];

const NCAA_TEAMS = [
  'Akron',
  'Alabama',
  'Arizona',
  'Arkansas',
  'Auburn',
  'BYU',
  'Baylor',
  'Boise State',
  'Charleston',
  'Clemson',
  'Colgate',
  'Colorado',
  'Colorado State',
  'Connecticut',
  'Creighton',
  'Dayton',
  'Drake',
  'Duke',
  'Florida',
  'Florida Atlantic',
  'Gonzaga',
  'Grambling State',
  'Houston Cougars',
  'Howard',
  'IOWA',
  'ISU',
  'Illinois',
  'James Madison',
  'Kansas',
  'Kentucky',
  'Long Beach State',
  'Longwood',
  'Marquette',
  'McNeese State',
  'Michigan State',
  'Michigan',
  'Mississippi State',
  'Montana State',
  'Morehead State',
  'NC State',
  'Nebraska',
  'Nevada',
  'New Mexico',
  'North Carolina',
  'Northwestern',
  'Oakland',
  'Oklahoma',
  'Oregon',
  'Purdue',
  'Saint Johns',
  'Saint Marys',
  'Saint Peters',
  'Samford',
  'San Diego',
  'Seton Hall',
  'South Carolina',
  'South Dakota State',
  'Stetson',
  'TCU',
  'Tennessee',
  'Texas',
  'Texas AM',
  'Texas Tech',
  'Utah State',
  'Vermont',
  'Virginia',
  'Wagner',
  'Washington State',
  'Western Kentucky',
  'Wisconsin',
];

const MLB_TEAMS = [
  'Arizona Diamondbacks',
  'Atlanta Braves',
  'Baltimore Orioles',
  'Boston Red Sox',
  'Chicago Cubs',
  'Chicago White Sox',
  'Cincinnati Reds',
  'Cleveland Guardians',
  'Colorado Rockies',
  'Detroit Tigers',
  'Houston Astros',
  'Kansas City Royals',
  'Los Angeles Angels',
  'Los Angeles Dodgers',
  'Miami Marlins',
  'Milwaukee Brewers',
  'Minnesota Twins',
  'New York Mets',
  'New York Yankees',
  'Oakland Athletics',
  'Philadelphia Phillies',
  'Pittsburgh Pirates',
  'San Diego Padres',
  'San Francisco Giants',
  'Seattle Mariners',
  'St. Louis Cardinals',
  'Tampa Bay Rays',
  'Texas Rangers',
  'Toronto Blue Jays',
  'Washington Nationals',
];

const WORLD_CUP_TEAMS = [
  'Turkey',
  'Germany',
  'Brazil',
  'Bosnia',
  'Korea Republic',
  'Egypt',
  'Cape Verde',
  'Switzerland',
  'USA',
  'Scotland',
  'Panama',
  'Japan',
  'Austria',
  'Colombia',
  'Qatar',
  'Morocco',
  'Iran',
  'Uruguay',
  'Sweden',
  'Haiti',
  'Croatia',
  'Spain',
  'New Zealand',
  'Netherlands',
  'Uzbekistan',
  'Jordan',
  'Iraq',
  'Argentina',
  'Curacao',
  'Algeria',
  'Tunisia',
  'Mexico',
  'Ghana',
  'Norway',
  'Congo DR',
  'Canada',
  'Belgium',
  'Czechia',
  'England',
  'Saudia Arabia',
  'Paraguay',
  'Australia',
  'South Africa',
  'Portugal',
  'Senegal',
  'Ivory Coast',
  'Ecuador',
  'France',
];

const UCL_TEAMS = ['Arsenal', 'Atletico', 'Bayern_Munich', 'PSG'];

const NFL_TEAMS = [
  'Arizona_Cardinals',
  'Atlanta_Falcons',
  'Baltimore_Ravens',
  'Buffalo_Bills',
  'Carolina_Panthers',
  'Chicago_Bears',
  'Cincinnati Bengals',
  'Cleveland_Browns',
  'Dallas_Cowboys',
  'Denver_Broncos',
  'Detroit_Lions',
  'Green_Bay_Packers',
  'Houston_Texans',
  'Indianapolis_Colts',
  'Jacksonville_Jaguars',
  'Kansas_City_Chiefs',
  'Las_Vegas_Raiders',
  'Los_Angeles_Chargers',
  'Los_Angeles_Rams',
  'Miami_Dolphins',
  'Minnesota_Vikings',
  'New_England_Patriots',
  'New_Orleans_Saints',
  'New_York_Giants',
  'New_York_Jets',
  'Philadelphia_Eagles',
  'Pittsburgh_Steelers',
  'Seattle_Seahawks',
  'San_Francisco_49ers',
  'Tampa_Bay_Buccaneers',
  'Tennessee_Titans',
  'Washington_Commanders',
];

export const TEAMS = {
  NHL: NHL_TEAMS,
  PROPS: PROP_OPTIONS,
  OLYMPICS: OLYMPIC_TEAMS,
  NBA: NBA_TEAMS,
  NCAA: NCAA_TEAMS,
  MLB: MLB_TEAMS,
  UCL: UCL_TEAMS,
  NFL: NFL_TEAMS,
  WORLD_CUP: WORLD_CUP_TEAMS,
} as const;
